import { BaseViewStore } from 'core/stores';
import { action, computed, makeObservable, observable } from 'mobx';
import { LookupStore } from 'modules/lookup/stores';
import { lookupRouteName } from 'common/constants';
import _ from 'lodash';

class PickingModeCarrierTypesViewStore extends BaseViewStore {
	@observable carrierTypes = [];

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.lookupStore = new LookupStore(rootStore);
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		await this.lookupStore.find({ page: 1, rpp: 100 }, lookupRouteName.carrierType);
		this.carrierTypes = this.lookupStore.data;
		_.forEach(this.carrierTypes, item => {
			item.isChecked = false;
		});
		this.resume();
	};

	@action.bound
	onCheck = item => {
		item.isChecked = !item.isChecked;
	};

	@action.bound
	onSelectAllCheck = () => {
		const selectAll = this.isSelectAllChecked;
		_.forEach(this.carrierTypes, item => {
			item.isChecked = !selectAll;
		});
	};

	@action.bound
	submit = async () => {
		let values = this.carrierTypes
			.filter(item => item.isChecked)
			.map(item => {
				return { value: item.name };
			});
		this.modalParams.data.queryUtility.filter.advancedSearch = [
			{
				condition: 4,
				fieldName: 'CarrierService.CarrierType.Name',
				filterValue: values,
			},
		];
		let carrierTypeColumn = _.find(
			this.modalParams.data.parentViewStore.tableData.columns,
			column => column.key === 'carrierType'
		);
		if (carrierTypeColumn) {
			carrierTypeColumn.filter = {
				selected: values.map(item => item.value),
				freeType: '',
				specificDate: null,
				dateRangeStart: null,
				dateRangeEnd: null,
				specificNumber: null,
				numberRangeStart: null,
				numberRangeEnd: null,
			};
		}
		this.modalParams.close();
		await this.modalParams.data.fetchFunction();
	};

	@computed get isSelectAllChecked() {
		return this.carrierTypes && this.carrierTypes.length && this.carrierTypes.every(item => item.isChecked);
	}
}

export default PickingModeCarrierTypesViewStore;
